module.exports = __webpack_public_path__ + "img/Layer 8@2x.88e79b19.png";